import React from "react";
import { Button } from "reactstrap";
import { customFieldsCopy } from "./copy";
import type { RequiredField } from "./publishFields";
import { focusTaxonomyField } from "./values";

type Props = {
  fields: RequiredField[];
};

const TaxonomyRequiredSummary = ({ fields }: Props) => {
  if (!fields.length) return null;
  const count = fields.length;
  return (
    <div className="hkp-tax-publish-error" role="alert">
      <strong>{customFieldsCopy.unableToPublish}</strong>
      <p className="mb-2">
        {count} required custom field{count === 1 ? " is" : "s are"} incomplete:
      </p>
      <ul>
        {fields.map((field) => (
          <li key={field.focusId || field.taxonomyId}>{field.name}</li>
        ))}
      </ul>
      <Button
        color="primary"
        size="sm"
        type="button"
        onClick={() => focusTaxonomyField(fields[0].taxonomyId, fields[0].focusId)}
      >
        {customFieldsCopy.completeRequired}
      </Button>
    </div>
  );
};

export default TaxonomyRequiredSummary;
